const InvoiceListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    showSlot:true,
    formData:{},
    formField:[
        {
            // name:'invoice.orderType', // 发票类型
            key:'invoice_type',
            type:'select',   
            // allowClear:true,
            optionToLocale:true,
            width:'170px',
            placeholder:'invoice.invoiceType',
            options:[
                {
                    label:'invoice.normalInvoice',
                    value:1,
                    disabled: false
                },
                {
                    label:'invoice.prepaidInvoice',
                    value:5,
                    disabled: false
                },
                {
                    // 红字发票：由退款与红字导入写入（INVOICE_TYPE = 2）
                    label:'invoice.creditNote',
                    value:2,
                    disabled: false
                }
            ]
        },
        {
            // name:'invoice.orderName', // 订单号
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'invoice.orderName',
        },
        {
            // name:'invoice.invoiceChildType', // 出库单号
            key:'invoice_child_type',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'invoice.invoiceChildType',
        },
        {
            // name:'invoice.invoiceNo', // 发票号
            key:'invoice_no',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'invoice.invoiceNo',
        },
        {
            // name:'invoice.invoiceVaildStatus', // 发票状态
            key:'valid_flag',
            type:'select',
            optionToLocale:true,
            width:'180px',
            placeholder:'invoice.invoiceVaildStatus',
            options:[
                {
                    label:'invoice.vaild',
                    value:0,
                },
                {
                    label:'invoice.invaild',
                    value:1,
                }
            ]
        },
        {
            // name:'invoice.orderType', // 订单类型
            key:'order_channel_type',
            type:'select',   
            allowClear:true,
            optionToLocale:true,
            width:'120px',
            placeholder:'invoice.orderType',
            options:[
                {
                    label:'order.user',
                    value:0,
                },
                {
                    label:'order.dealer',
                    value:1,
                },
                {
                    label:'order.service',
                    value:4,
                },
                {
                    label:'order.c2c',
                    value:5,
                }
            ]
        },
        {
            // name:'invoice.payStatus', // 付款状态
            key:'pay_status',
            type:'select',
            allowClear:true,
            optionToLocale:true,
            width:'170px',
            placeholder:'invoice.payStatus',
            options:[
                {
                    label:'order.obligation',
                    value:7,
                },
                {
                    label:'order.partialPay',
                    value:0,
                },
                {
                    label:'order.pay',
                    value:1,
                },
            ]
        },
        {
            name:'', // 发票日期
            key:'create_timestamp',
            type:'dateRange',
            showTime:false,
            allowClear:true,
            width:'330px',
        },
    ]
}

const InvoiceOrdreListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    showSlot:true,
    formData:{},
    formField:[
        {
            // name:'invoice.orderName', // 订单号
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'250px',
            placeholder:'invoice.orderName',
        },
        {
            // name:'invoice.orderName', // 类型：实物订单/服务订单
            key:'order_channel_type',
            type:'select',   
            allowClear:false,
            width:'250px',
            placeholder:'order.type',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.ebikeOrder'
                },
                {
                    value:4,
                    label:'order.serviceOrder'
                },
            ]
        },
        {
            // name:'invoice.orderName', // 发货状态
            key:'courier_status',
            type:'select',   
            allowClear:true,
            width:'250px',
            placeholder:'order.courierStatus',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.unship'
                },
                {
                    value:1,
                    label:'order.plan'
                },
                {
                    value:2,
                    label:'order.partialShip'
                },
                {
                    value:3,
                    label:'order.shiped'
                },
                {
                    value:4,
                    label:'order.signedFor'
                },
                {
                    value:5,
                    label:'order.canceled'
                },
                {
                    value:7,
                    label:'order.partialReturn'
                },
                {
                    value:8,
                    label:'order.return'
                },
                {
                    value:10,
                    label:'order.partialExchange'
                },
                {
                    value:9,
                    label:'order.exchange'
                },
                {
                    value:99,
                    label:'order.noNeedToShip'
                },
            ]
        },
    ]
}

const InvoiceOutboundListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    showSlot:true,
    formData:{},
    formField:[
        {
            // name:'invoice.orderName', // 订单号
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'250px',
            placeholder:'invoice.orderName',
        },
        {
            // name:'invoice.orderName', // 出库单号
            key:'delivery_number',
            type:'input',   
            allowClear:true,
            width:'250px',
            placeholder:'invoice.deliveryNumber',
        },
        {
            // name:'invoice.orderName', // 出库状态
            key:'status',
            type:'select',   
            allowClear:true,
            show:true,
            width:'250px',
            placeholder:'invoice.outboundStatus',
            optionToLocale:true,
            options:[
                {
                    value:1,
                    label:'invoice.unOutbound'
                },
                {
                    value:4,
                    label:'invoice.outScanned'  
                },
                {
                    value:2,
                    label:'invoice.outbound'
                },
                {
                    value:3,
                    label:'invoice.cancelOutbound'
                },
            ]
        },
        {
            // name:'invoice.orderName', // 订单类型
            key:'order_channel_type',
            type:'select',   
            allowClear:false,
            width:'250px',
            placeholder:'order.orderChannelType',
            optionToLocale:true,
            options:[
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:5,
                    label:'order.c2c'
                },
            ]
        },
    ]
}



InvoiceListQuery.formField.forEach(item=>{
    InvoiceListQuery.formData[item.key] = ''
})

InvoiceOrdreListQuery.formField.forEach(item=>{
    InvoiceOrdreListQuery.formData[item.key] = ''
})

InvoiceOutboundListQuery.formField.forEach(item=>{
   InvoiceOutboundListQuery.formData[item.key] = ''
})

export {
    InvoiceListQuery,
    InvoiceOrdreListQuery,
    InvoiceOutboundListQuery
}